export default function WhyUs() {
    const whyUsData = [
      {
        icon: <SearchIcon />,
        title: "Full HPI Check",
        desc: "Every vehicle undergoes a comprehensive history and provenance check.",
      },
      {
        icon: <ShieldIcon />,
        title: "12-Month Warranty",
        desc: "Drive away with confidence — all vehicles include our 12-month warranty.",
      },
      {
        icon: <CardIcon />,
        title: "Flexible Finance",
        desc: "PCP, HP and personal loan options available. Get approved in minutes.",
      },
      {
        icon: <CarIcon />,
        title: "Part Exchange",
        desc: "Trade in your current car — we'll assess it on the spot.",
      },
    ];
  
    return (
      <section style={section}>
        <div style={container}>
  
          {/* HEADER */}
          <div style={header}>
            <div style={tag}>Why Choose Us</div>
  
            <h2 style={title}>The PRG Difference</h2>
          </div>
  
          {/* GRID */}
          <div style={grid}>
            {whyUsData.map((item, index) => (
              <div key={index} style={card} className="why-card">
  
                {/* ICON */}
                <div style={iconWrap}>
                  {item.icon}
                </div>
  
                {/* TITLE */}
                <h3 style={cardTitle}>{item.title}</h3>
  
                {/* DESC */}
                <p style={cardDesc}>{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
  
        {/* HOVER STYLES */}
        <style>{`
          .why-card:hover {
            transform: translateY(-6px);
            border-color: #FFD700;
            box-shadow: 0 10px 30px rgba(255,215,0,0.08);
          }
        `}</style>
      </section>
    );
  }
  
  /* ── SVG ICONS ── */
  
  function SearchIcon() {
    return (
      <svg width="22" height="22" fill="none" stroke="black" strokeWidth="2">
        <circle cx="10" cy="10" r="6" />
        <line x1="15" y1="15" x2="21" y2="21" />
      </svg>
    );
  }
  
  function ShieldIcon() {
    return (
      <svg width="22" height="22" fill="none" stroke="black" strokeWidth="2">
        <path d="M12 2L4 6v6c0 5 3.5 9 8 10 4.5-1 8-5 8-10V6l-8-4z" />
      </svg>
    );
  }
  
  function CardIcon() {
    return (
      <svg width="22" height="22" fill="none" stroke="black" strokeWidth="2">
        <rect x="2" y="5" width="20" height="14" rx="2" />
        <line x1="2" y1="10" x2="22" y2="10" />
      </svg>
    );
  }
  
  function CarIcon() {
    return (
      <svg width="22" height="22" fill="none" stroke="black" strokeWidth="2">
        <rect x="3" y="8" width="18" height="6" rx="2" />
        <circle cx="7" cy="16" r="2" />
        <circle cx="17" cy="16" r="2" />
      </svg>
    );
  }
  
  /* ── STYLES ── */
  
  const section = {
    padding: '70px 16px',
    background: '#0a0a0a',
  };
  
  const container = {
    maxWidth: '1200px',
    margin: '0 auto',
  };
  
  const header = {
    textAlign: 'center' as const,
    marginBottom: '40px',
  };
  
  const tag = {
    fontSize: '12px',
    color: '#FFD700',
    fontWeight: 600,
    marginBottom: '6px',
    letterSpacing: '1px',
  };
  
  const title = {
    fontSize: '28px',
    fontWeight: 700,
  };
  
  const grid = {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))',
    gap: '20px',
  };
  
  const card = {
    background: '#111',
    border: '1px solid #1e1e1e',
    borderRadius: '16px',
    padding: '22px',
    display: 'flex',
    flexDirection: 'column' as const,
    gap: '12px',
    transition: '0.3s',
    borderBottom:'2px solid white',
    borderLeft:'2px solid #616215',
  };
  
  const iconWrap = {
    width: '48px',
    height: '48px',
    borderRadius: '14px',
    background: '#FFD700',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  };
  
  const cardTitle = {
    fontSize: '16px',
    fontWeight: 600,
  };
  
  const cardDesc = {
    fontSize: '13px',
    color: '#aaa',
    lineHeight: 1.6,
  };